import { PickRequired } from "@/utils/types.ts";
import { PortfolioDocument as ApiPortfolioDocument } from "@/api";

export const enum PortfolioItemType {
  URL = "URL",
  FILE = "FILE",
  PROJECT = "PROJECT",
}

export type FileType = "application/pdf" | "image/jpeg" | "image/png";

export type PortfolioItemUrl = PickRequired<ApiPortfolioDocument> &
  Pick<ApiPortfolioDocument, "id" | "url" | "createdAt">;
export type PortfolioItemFile = PickRequired<ApiPortfolioDocument> &
  Pick<ApiPortfolioDocument, "id" | "file" | "createdAt">;
export type PortfolioItemProject = PickRequired<ApiPortfolioDocument> &
  Pick<ApiPortfolioDocument, "id" | "project" | "createdAt">;
export type PortfolioDocument = PortfolioItemUrl | PortfolioItemFile | PortfolioItemProject;

// Typehelper utilities
export function isPortfolioItemLink(item: PortfolioDocument): item is PortfolioItemUrl {
  return item.type === PortfolioItemType.URL;
}

export function isPortfolioItemFile(item: PortfolioDocument): item is PortfolioItemFile {
  return item.type === PortfolioItemType.FILE;
}

export function isPortfolioItemProject(item: PortfolioDocument): item is PortfolioItemProject {
  return item.type === PortfolioItemType.PROJECT;
}
